module.exports = __webpack_public_path__ + "media/images/shared/logotypes/logo_tyreso-56e4f36dfd4a53ea3af5faa597fcf9a4.png";